import { Component, OnInit, Injector } from '@angular/core';
import { LoginService } from '../../core/service/login.service';
import { MediaObserver } from '@angular/flex-layout';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EnvconfigService } from 'src/app/core/service/envconfig.service';
import { EncryptDecryptService } from 'src/app/core/service/EncryptDecryptService.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent implements OnInit {
  deviceXs!: boolean;
  public username: string = '';
  public mode: any;

  constructor(
    private routers: Router,
    public loginService: LoginService,
    public injector: Injector,
    public mediaObserver: MediaObserver,
    private environment: EnvconfigService,
    private JwtHelper: JwtHelperService,
    private encryptService: EncryptDecryptService,
  ) {
    let token = sessionStorage.getItem(environment.get('TOKEN_NAME'))!;
    let _token = this.encryptService.decrypt(
      token,
      environment.get('keyCaptcha'),
    );
    JwtHelper.decodeToken(_token);
    this.username = sessionStorage.getItem(environment.get('USERNAME'))!;
  }

  ngOnInit(): void {
    this.mode = 'side';
    this.deviceXs = true;
  }

  CerraSessionMain() {
    //  this.loginService.cerrarSesion();
    this.loginService
      .desabilitarToken()
      .pipe(
        finalize(() => {
 
          this.loginService.cerrarSesion();
        }),
      )
      .subscribe({
        next: (response) => {
          console.log('Servidor: Sesión cerrada con éxito');
        },
        error: (err) => {
           
          console.error('Error al deshabilitar token en servidor:', err);
           
        },
      });
 
  }

  
}
